var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seo-links"},[_c('ul',_vm._l((_vm.links),function(link,idx){return _c('li',{key:`link_${idx}`},[_c('NuxtLink',{staticClass:"text-link",attrs:{"to":link.url,"title":link.title}},[_vm._v("\n        "+_vm._s(link.text)+" Jobs\n      ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }